import React from 'react';
import { UpgradeModal } from './UpgradeModal';
import { useUpgradeModal } from './UpgradeModalContext';

/**
 * Root component that renders the UpgradeModal
 * Place this inside the UpgradeModalProvider, typically at the app root
 */
export const UpgradeModalRoot: React.FC = () => {
  const { isOpen, feature, closeUpgradeModal } = useUpgradeModal();

  return (
    <UpgradeModal
      isOpen={isOpen}
      onClose={closeUpgradeModal}
      feature={feature}
    />
  );
};

export default UpgradeModalRoot;
